import { render, staticRenderFns } from "./Auth.view.vue?vue&type=template&id=3aac85fc&"
import script from "./Auth.view.vue?vue&type=script&lang=js&"
export * from "./Auth.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports